import * as React from "react";
import { useFormContext } from 'react-hook-form';
import Select, { createFilter, ValueType } from 'react-select';
import { SelectStyles } from "soprasteria-ui-library";
import { IOrthodonticReferralDecision } from "../../../models/IOrthodonticReferral";

interface IOption {
    value: string;
    label: string;
    selected?: boolean;
}

interface IOrthodonticReferralDecisionDropdown {
    label: string;
    decisions: IOrthodonticReferralDecision[];
    defaultValue?: string | string[];
    labelCol?: number;
    inputCol?: number;
    name: string;
    isLoading?: boolean;
    isMultiple?: boolean;
}

export const OrthodonticReferralDecisionDropdown: React.FunctionComponent<IOrthodonticReferralDecisionDropdown> = ({ decisions, defaultValue, labelCol, inputCol, name, isLoading, isMultiple, label }) => {

    const { register, setValue, errors, unregister, clearError } = useFormContext();
    const [selectedValue, setSelectedValue] = React.useState<IOption | IOption[]>();
    const [orthodonticReferralDecisionOptions, setOrthodonticReferralDecisionOptions] = React.useState<IOption[]>()
    const selectRef = React.useRef<any>();

    React.useEffect(() => {
        return () => {
            clearError(name);
            unregister(name);
        }
    }, [])

    React.useEffect(() => {
        if (decisions && decisions.length > 1) {
            document.getElementById("clear-form")?.addEventListener("click", resetValue);
        }

        return () => {
            document.getElementById("clear-form")?.removeEventListener("click", resetValue);
        }
    }, [decisions])

    const resetValue = () => {
        if (selectRef?.current) {
            selectRef.current.select.clearValue();
            setValue(name, isMultiple ? [] : undefined);
            setSelectedValue(undefined)
        }
    }

    React.useEffect(() => {
        register({ name: name });
        const options = decisions.map<IOption>((decision) => {
            return {
                value: decision.orthodonticReferralDecisionId.toString(),
                label: decision.description,
                selected: typeof defaultValue === "string" || typeof defaultValue === "undefined"
                    ? decision.orthodonticReferralDecisionId.toString() === defaultValue
                    : defaultValue.includes(decision.orthodonticReferralDecisionId.toString())
            }
        });

        const initalValue = options.filter((option) => { return option.selected === true });
        if (!isMultiple && initalValue.length === 1) {
            setValue(name, initalValue[0].value);
            setSelectedValue(initalValue[0]);
        }
        else if (isMultiple) {
            setValue(name, initalValue ? initalValue.map((val) => { return val.value }) : []);
            setSelectedValue(initalValue ? initalValue : []);
        }

        setOrthodonticReferralDecisionOptions(options);

    }, [, decisions]);

    const onChange = (selectedOption: any | null) => {
        if (selectedOption && selectedOption.length !== 0) {
            if (isMultiple) {
                const values = selectedOption.map((option: any) => { return option.value })

                if (orthodonticReferralDecisionOptions) {
                    let options = orthodonticReferralDecisionOptions;
                    for (var i = 0; i < options.length; i++) {
                        if (selectedOption.some((selected: any) => selected.value !== options[i].value)) {
                            options[i].selected = false;
                        }
                    }
                    setOrthodonticReferralDecisionOptions(options);
                }

                setValue(name, values);
                setSelectedValue(selectedOption)
            }
            else {
                setValue(name, selectedOption.value);
                setSelectedValue(selectedOption)
            }
        }
        else {
            if (orthodonticReferralDecisionOptions) {
                let options = orthodonticReferralDecisionOptions;
                for (var i = 0; i < options.length; i++) {
                    options[i].selected = false;
                }
                setOrthodonticReferralDecisionOptions(options);
            }
            setValue(name, isMultiple ? [] : undefined);
            setSelectedValue(isMultiple ? [] : undefined)
        }
    }

    return (
        <div className="form-group row">
            <label className={`col-${labelCol ?? 4} col-form-label`}>{label}:</label>
            <div className={`col-${inputCol ?? 8}`}>
                <Select
                    ref={selectRef}
                    placeholder={"Välj beslut"}
                    filterOption={createFilter({ ignoreAccents: false })}
                    styles={SelectStyles}
                    options={orthodonticReferralDecisionOptions}
                    isOptionSelected={(option: IOption) => option.selected === true}
                    value={selectedValue}
                    isLoading={isLoading}
                    loadingMessage={() => "Laddar"}
                    isMulti={isMultiple}
                    onChange={(selectedOption: any) => onChange(selectedOption)}
                />
                <span className="text-danger">{errors ? [name] && (errors[name] as any)?.type === "required" && "Välj ett beslut" : ""}</span>
            </div>
        </div>
    )
}